import { render, staticRenderFns } from "./client-devices.vue?vue&type=template&id=6618dbad&"
import script from "./client-devices.vue?vue&type=script&lang=js&"
export * from "./client-devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports